import { tactics } from "@/mocks/media";

export default function Tactics() {
  return (
    <section id="tactics" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-primary-500" />
              <span className="text-xs font-medium uppercase tracking-[0.25em] text-primary-500">
                METHOD FILE
              </span>
            </div>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              四大常规模板手法
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
              把舆论场里反复出现的手法拆开来看：它们如何被使用，以及普通人可以怎样保持判断。
            </p>
          </div>
          <span className="hidden whitespace-nowrap text-xs text-foreground-500 md:inline-flex">
            A / B / C / D · 四份手法档案
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
          {tactics.map((t) => (
            <article
              key={t.index}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-52 overflow-hidden md:h-60">
                <img
                  src={t.image}
                  alt={t.alt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 font-heading text-xl font-bold text-background-50">
                  {t.index}
                </span>
                <div className="absolute bottom-3 right-4 text-right">
                  <p className="font-heading text-2xl font-bold text-white drop-shadow">{t.title}</p>
                  <p className="text-[10px] uppercase tracking-[0.3em] text-accent-300">{t.en}</p>
                </div>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <p className="text-sm font-medium leading-6 text-foreground-900">{t.desc}</p>
                <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{t.detail}</p>
                <div className="mt-4 rounded-md bg-accent-50 px-4 py-3">
                  <p className="text-xs leading-6 text-accent-900">
                    <span className="font-medium">如何识别：</span>
                    {t.signal}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}